import { useTranslation } from 'react-i18next';

import { useLogout } from '~/api/auth';
import { useUser } from '~/api/user';
import { Button, Menu } from '~/components';

import { useMenuItems } from '../Navigation.hooks';
import { topBarMenuTriggerStyle } from './TopBar.css';

export const TopBarMenu = () => {
  const { data: user } = useUser();
  const items = useMenuItems();
  const logoutMutation = useLogout();

  const { t } = useTranslation(['common']);

  return (
    <Menu.Root>
      <Menu.Trigger
        render={
          <Button className={topBarMenuTriggerStyle} icon="ChevronDown" iconPlacement="right">
            {user.firstName}
          </Button>
        }
      />

      <Menu.List>
        {items.map((item) => (
          <Menu.LinkItem icon={item.icon} key={item.label} to={item.to}>
            {item.label}
          </Menu.LinkItem>
        ))}

        <Menu.Item icon="Logout" onClick={() => logoutMutation.mutate()}>
          {t('common:topbar.dropdown.logout')}
        </Menu.Item>
      </Menu.List>
    </Menu.Root>
  );
};
